var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "terms-outline" },
    [
      _c("p", { staticClass: "title" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("terms." + _vm.region + ".tenantTermOfUse.title")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("TermSections", {
        attrs: { sections: _vm.termsSections, level: 1, indexDelimiter: "" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }